import React from "react";
import { LANGUAGES, useI18n } from "@/i18n";
import { pathForLang } from "@/lib/seo";

// Plain <a> links, deliberately not client-side navigation: each language is its own
// document with its own prerendered HTML and canonical URL. Real anchors are also what
// lets a crawler walk from one translation to the next without relying on <link
// rel="alternate"> alone.
//
// `hrefFor` exists because the landing pages are not the only prerendered cluster: on the
// privacy policy the switcher has to walk to the other *policy* URLs, not back to the
// marketing ones, or the page and its own hreflang cluster disagree.
export function LanguageSwitcher({ className = "", hrefFor = pathForLang }) {
  const { lang, t } = useI18n();
  return (
    <nav
      aria-label={t("lang_switch_label")}
      data-testid="language-switcher"
      className={`flex items-center gap-1 ${className}`}
    >
      {LANGUAGES.map((l) => {
        const active = l.code === lang;
        return (
          <a
            key={l.code}
            href={hrefFor(l.code)}
            hrefLang={l.code}
            lang={l.code}
            title={l.label}
            aria-current={active ? "true" : undefined}
            data-testid={`lang-link-${l.code}`}
            className={`rounded px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider transition-colors ${
              active ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100 hover:text-slate-900"
            }`}
          >
            {l.code}
          </a>
        );
      })}
    </nav>
  );
}

export default LanguageSwitcher;
